<script setup lang="ts">
  import { computed } from 'vue';
  import { ColoredButton, SearchBar, SearchToolbar, SelectInput, TabsMenu } from '@/shared/ui';
  import ExportExcelIcon from '@/shared/assets/icons/ExportExcel.svg';

  type TabOption = {
    id: string;
    text: string;
  };

  interface QuantityOption {
    id: string | number;
    name: string;
  }

  interface SearchField {
    id: string;
    name: string;
  }

  interface Props {
    tabs: TabOption[];
    activeTab: string;
    isGeneralHistoryTab: boolean;
    itemsPerPage: number;
    quantityOptions: QuantityOption[];
    searchFields: SearchField[];
    isExportDisabled: boolean;
  }

  const props = defineProps<Props>();

  const searchRowClass = computed(() =>
    props.isGeneralHistoryTab
      ? 'flex w-full flex-col items-start gap-4'
      : 'mb-6 flex w-full flex-col items-start gap-4'
  );

  const emit = defineEmits<{
    (e: 'tab-change', tabId: string): void;
    (e: 'search', term: string): void;
    (e: 'items-per-page-change', value: string | number): void;
    (e: 'export-click'): void;
  }>();
</script>

<template>
  <TabsMenu
    class="mb-6 h-10"
    :options="tabs"
    :selected-option="activeTab"
    @option-selected="(value) => emit('tab-change', value)"
  />

  <div
    :class="searchRowClass"
    data-testid="reminder-history-search-row"
  >
    <ColoredButton
      class="shrink-0"
      text="Exportar para Excel"
      :icon="ExportExcelIcon"
      icon-alt="Exportar"
      :disabled="isExportDisabled"
      @click="emit('export-click')"
    />

    <SearchToolbar>
      <template #search>
        <SearchBar @search="(value) => emit('search', value)" />
      </template>
      <template #quantity>
        <SelectInput
          :model-value="itemsPerPage"
          :options="quantityOptions"
          @update:model-value="(value) => emit('items-per-page-change', value)"
        />
      </template>
    </SearchToolbar>
  </div>
</template>
